import React, { useState, useEffect } from 'react';
import {
  Box, Button, FormControl, IconButton, MenuItem,
  Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Typography, Menu, ListItemIcon, ListItemText, Pagination, Checkbox, CircularProgress
} from '@mui/material';
import { History, MoreVert, List, Edit, Add } from '@mui/icons-material';
import Navbar from '../Layouts/Navbar';
import Snackbar from '@mui/material/Snackbar';
import ApartmentIcon from '@mui/icons-material/Apartment';
import MuiAlert from '@mui/material/Alert';
import HistoriqueModal from './HistoriqueModal';
import DeleteIcon from '@mui/icons-material/Delete';
import AddModal from './AddModal';
import UpdateModal from './UpdateModal';
import DetailsModal from './DetailsModal';
import api from '../../utils/api';



export default function SocieteTable() {
  const [openhis, setOpenHis] = useState(false);
  const handleOpenHis = () => setOpenHis(true);
  const handleCloseHis = () => setOpenHis(false);

  const [openadd, setOpenAdd] = useState(false);
  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => {
    setOpenAdd(false);
    fetchSocietes(); // Refresh data after adding
  };

  const [openupd, setOpenUpd] = useState(false);
  const handleOpenUpd = () => setOpenUpd(true);
  const handleCloseUpd = () => {
    setOpenUpd(false);
    fetchSocietes(); // Refresh data after updating
  };

  const [opendet, setOpenDet] = useState(false);
  const handleOpenDet = () => setOpenDet(true);
  const handleCloseDet = () => setOpenDet(false);
  
  const [loading, setLoading] = useState(true);
  const [societes, setSocietes] = useState([]);
  const [currentSociete, setCurrentSociete] = useState(null);



  const [snack, setSnack] = useState({ open: false, message: '', type: 'success' });
  const handleSnack = (message, type = 'success') => {
    setSnack({ open: true, message, type });
  };
  
  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnack({ ...snack, open: false });
  };

  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [menuRowId, setMenuRowId] = useState(null);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  
  // State for selected rows/checkboxes
  const [selected, setSelected] = useState([]);
  const [groupAction, setGroupAction] = useState('');
  
  // Fetch societes from API
  const fetchSocietes = async () => {
    setLoading(true);
    try {
      const response = await api.get('/societes');
      setSocietes(response.data);
    } catch (error) {
      console.error('Error fetching societes:', error);
      
      // Handle specific error messages from server
      if (error.response && error.response.data) {
        if (typeof error.response.data === 'object' && error.response.data.message) {
          handleSnack(error.response.data.message, 'error');
        } else if (typeof error.response.data === 'string') {
          handleSnack(error.response.data, 'error');
        } else {
          handleSnack('Erreur lors du chargement des sociétés', 'error');
        }
      } else if (error.message) {
        handleSnack(`Erreur: ${error.message}`, 'error');
      } else {
        handleSnack('Erreur lors du chargement des sociétés', 'error');
      }
    } finally {
      setLoading(false);
    }
  };
  
  // Load societes on component mount
  useEffect(() => {
    fetchSocietes();
  }, []);
  

  const handleDelete = async () => {
    try {
      if (menuRowId) {
        await api.delete(`/societes/${menuRowId}`);
        handleSnack('Société supprimée avec succès', 'success');
        fetchSocietes(); // Refresh data after deletion
      } else if (selected.length > 0) {
        // Handle bulk delete
        const deletePromises = selected.map(id => api.delete(`/societes/${id}`));
        await Promise.all(deletePromises);
        handleSnack('Sociétés supprimées avec succès', 'success');
        setSelected([]);
        fetchSocietes();
      }
      handleMenuClose();
    } catch (error) {
      console.error('Error deleting societe(s):', error);
      
      // Handle specific error messages from server
      if (error.response && error.response.data) {
        if (typeof error.response.data === 'object' && error.response.data.message) {
          handleSnack(error.response.data.message, 'error');
        } else if (typeof error.response.data === 'string') {
          handleSnack(error.response.data, 'error');
        } else {
          handleSnack("Erreur lors de la suppression de la société", 'error');
        }
      } else if (error.message) {
        handleSnack(`Erreur: ${error.message}`, 'error');
      } else {
        handleSnack("Erreur lors de la suppression de la société", 'error');
      }
    }
  };

  const handleModify = (societe) => {
    setCurrentSociete(societe);
    handleOpenUpd();
    handleMenuClose();
  };
  
  const handleViewDetails = (societe) => {
    setCurrentSociete(societe);
    handleOpenDet();
    handleMenuClose();
  };
  
  // Handle toggle status
  const handleToggleStatus = async (id, currentStatus) => {
    try {
      // Send PATCH request to update only the status field
      await api.patch(`/societes/${id}`, { Status: currentStatus === 1 ? 0 : 1 });
      fetchSocietes();
      handleSnack("Statut mis à jour avec succès", "success");
    } catch (error) {
      console.error("Error updating status:", error);
      
      // Handle specific error messages from server
      if (error.response && error.response.data) {
        if (typeof error.response.data === 'object') {
          if (error.response.data.errors && error.response.data.errors.Status) {
            // If there's a specific validation error for Status field
            handleSnack(error.response.data.errors.Status[0], "error");
          } else if (error.response.data.message) {
            handleSnack(error.response.data.message, "error");
          } else {
            handleSnack("Erreur lors de la mise à jour du statut", "error");
          }
        } else if (typeof error.response.data === 'string') {
          handleSnack(error.response.data, "error");
        } else {
          handleSnack("Erreur lors de la mise à jour du statut", "error");
        }
      } else if (error.message) {
        handleSnack(`Erreur: ${error.message}`, "error");
      } else {
        handleSnack("Erreur lors de la mise à jour du statut", "error");
      }
    }
  };

  const handleMenuClick = (event, societe) => {
    setAnchorEl(event.currentTarget);
    setMenuRowId(societe.ID_Societe);
    setCurrentSociete(societe);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(1);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelected = societes.map(n => n.ID_Societe);
      setSelected(newSelected);
    } else {
      setSelected([]);
    }
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    
    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleGroupAction = async () => {
    if (groupAction === 'Supprimer' && selected.length > 0) {
      try {
        const deletePromises = selected.map(id => api.delete(`/societes/${id}`));
        await Promise.all(deletePromises);
        handleSnack('Sociétés supprimées avec succès', 'success');
        setSelected([]);
        fetchSocietes();
        setGroupAction('');
      } catch (error) {
        console.error('Error deleting societes:', error);
        
        // Handle specific error messages from server
        if (error.response && error.response.data) {
          if (typeof error.response.data === 'object' && error.response.data.message) {
            handleSnack(error.response.data.message, 'error');
          } else if (typeof error.response.data === 'string') {
            handleSnack(error.response.data, 'error');
          } else {
            handleSnack('Erreur lors de la suppression des sociétés', 'error');
          }
        } else if (error.message) {
          handleSnack(`Erreur: ${error.message}`, 'error');
        } else {
          handleSnack('Erreur lors de la suppression des sociétés', 'error');
        }
      }
    }
  };

  const paginatedRows = societes.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  const pageCount = Math.ceil(societes.length / rowsPerPage);

  return (
    <Box>
      <Navbar />
      <Box p={2}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <ApartmentIcon />
            <Typography variant="h6">SOCIÉTÉS</Typography>
          </Box>
          <Box display="flex" gap={2}>
            <Button variant="outlined"
             onClick={handleOpenAdd}
            sx={{
              color: 'red',
              borderColor: 'red',
              textTransform: 'none',
              '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
            }} startIcon={<Add />}>Ajouter</Button>
          </Box>
        </Box>

        {/* Bulk Actions */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" gap={2}>
            <Typography>Actions groupées</Typography>
            <FormControl size="small" sx={{
                minWidth: 150 ,
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
              <Select
                value={groupAction}
                onChange={(e) => setGroupAction(e.target.value)}
                displayEmpty
              >
                <MenuItem value="" disabled><em>Sélectionner</em></MenuItem>
                <MenuItem value="Supprimer">Supprimer</MenuItem>
              </Select>
            </FormControl>
            <Button
              variant="contained"
              disabled={!groupAction || selected.length === 0}
              onClick={handleGroupAction}
              sx={{
                bgcolor: 'red',
                textTransform: 'none',
                '&:hover': { bgcolor: 'red' },
                '&.Mui-disabled': { bgcolor: '#f5f5f5', color: '#bdbdbd' }
              }}
            >
              Appliquer
            </Button>
          </Box>
          <Typography>{selected.length} sélectionnés / {societes.length} entrées</Typography>
        </Box>

        {/* Table */}
        <TableContainer component={Paper} variant="outlined">
            <Table>
                <TableHead>
                <TableRow>
                    <TableCell padding="checkbox">
                    <Checkbox
                        indeterminate={selected.length > 0 && selected.length < societes.length}
                        checked={societes.length > 0 && selected.length === societes.length}
                        onChange={handleSelectAll}
                        sx={{
                        '&.MuiCheckbox-indeterminate': { color: '#000' },
                        '&.Mui-checked': { color: '#000' },
                        }}
                    />
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Nom</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Téléphone</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Email</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Adresse</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Statut</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 3 }}>
                      <CircularProgress size={40} sx={{ color: 'red' }} />
                    </TableCell>
                  </TableRow>
                ) : paginatedRows.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 3 }}>
                      <Typography variant="body1">Aucune société trouvée</Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedRows.map((societe) => {
                    const isItemSelected = isSelected(societe.ID_Societe);
                    return (
                      <TableRow key={societe.ID_Societe} hover selected={isItemSelected}>
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={isItemSelected}
                            onChange={(event) => handleSelectOne(event, societe.ID_Societe)}
                            sx={{
                              '&.MuiCheckbox-indeterminate': { color: '#000' },
                              '&.Mui-checked': { color: '#000' },
                            }}
                          />
                        </TableCell>
                        <TableCell>{societe.name}</TableCell>
                        <TableCell>{societe.Téléphone || '-'}</TableCell>
                        <TableCell>{societe.email}</TableCell>
                        <TableCell>{societe.adresse}</TableCell>
                        <TableCell>
                          <Box
                            onClick={() => handleToggleStatus(societe.ID_Societe, societe.Status === 'Actif' || societe.Status === 1 || societe.Status === '1' ? 1 : 0)}
                            sx={{
                              backgroundColor: societe.Status === 'Actif' || societe.Status === 1 || societe.Status === '1' ? '#4caf50' : '#dc3545',
                              color: 'white',
                              borderRadius: '4px',
                              px: 1,
                              py: 0.5,
                              display: 'inline-block',
                              fontSize: '0.8rem',
                              textAlign: 'center',
                              minWidth: '60px',
                              cursor: 'pointer',
                              '&:hover': {
                                opacity: 0.8,
                              },
                            }}
                          >
                            {societe.Status === 'Actif' || societe.Status === 1 || societe.Status === '1' ? 'Actif' : 'Inactif'}
                          </Box>
                        </TableCell>
                        <TableCell>
                          <IconButton onClick={(e) => handleMenuClick(e, societe)}>
                            <MoreVert />
                          </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={menuRowId === societe.ID_Societe && openMenu}
                            onClose={handleMenuClose}
                            PaperProps={{
                            sx: {
                                minWidth: '200px',
                                '& .MuiMenuItem-root': {
                                color: 'black',
                                '& .MuiListItemIcon-root': { color: 'black' },
                                '&:hover': {
                                    backgroundColor: 'red',
                                    color: 'white',
                                    '& .MuiListItemIcon-root': { color: 'white' },
                                },
                                },
                            },
                            }}
                        >
                            <MenuItem onClick={() => handleViewDetails(currentSociete)}>
                            <ListItemIcon><List fontSize="small" /></ListItemIcon>
                            <ListItemText>Détail</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={() => handleModify(currentSociete)}>
                            <ListItemIcon><Edit fontSize="small" /></ListItemIcon>
                            <ListItemText>Modifier</ListItemText>
                            </MenuItem>
                            <MenuItem sx={{ color: 'red' }} onClick={handleOpenHis}>
                            <ListItemIcon sx={{ color: 'red' }}><History fontSize="small" /></ListItemIcon>
                            <ListItemText>Historique</ListItemText>
                            </MenuItem>
                            <MenuItem sx={{ color: 'red' }} onClick={handleDelete}>
                            <ListItemIcon sx={{ color: 'red' }}><DeleteIcon fontSize="small" /></ListItemIcon>
                            <ListItemText>Supprimer</ListItemText>
                            </MenuItem>
                        </Menu>
                        </TableCell>
                    </TableRow>
                    );
                })
                )}
                </TableBody>
            </Table>
        </TableContainer>

        {/* Pagination */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
          <Typography>{societes.length} entrées</Typography>
          <Box display="flex" gap={2} alignItems="center">
            <FormControl size="small" sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: '#000' },
                '&.Mui-focused fieldset': { borderColor: 'red' },
              }
            }}>
              <Select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </FormControl>
            <Pagination
              count={pageCount}
              page={page}
              onChange={handleChangePage}
              variant="outlined"
              shape="rounded"
            />
          </Box>
        </Box>
      </Box>

      <Snackbar 
        open={snack.open} 
        autoHideDuration={3000} 
        onClose={handleCloseSnack} 
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert 
          onClose={handleCloseSnack} 
          severity={snack.type} 
          elevation={6} 
          variant="filled" 
          sx={{ width: '100%', bgcolor: snack.type === 'success' ? 'green' : 'red' }}
        >
          {snack.message}
        </MuiAlert>
      </Snackbar>

    <HistoriqueModal open={openhis} handleClose={handleCloseHis} />
    <AddModal open={openadd} handleClose={handleCloseAdd} />
    <UpdateModal open={openupd} handleClose={handleCloseUpd} societe={currentSociete} />
    <DetailsModal open={opendet} handleClose={handleCloseDet} societe={currentSociete} />
    </Box>
  );
}